<template>
	<div class="loading-placeholder2">
		<socket size="112px" />
	</div>
</template>

<script>

export default {
	name: "LoadingPlaceholder2",
};
</script>

<style lang="scss" scoped>
.loading-placeholder2 {
	display: flex;
	align-content: center;
	justify-content: center;
	height: 100%;
	align-items: center;
}
</style>
